module.exports = __webpack_public_path__ + "img/vk.6d5b5f4c.svg";